import { Button, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

export const MachineDeletedModal = ({ visible }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACES.MACHINE_DETAILS);
  const history = useHistory();

  const goToMyMachines = useCallback(() => {
    history.push('/my-machines');
  }, [history]);

  return (
    <Modal
      title={t('deletionModal.deleted.title')}
      open={visible}
      className="base-modal no-select"
      closable={false}
      width={550}
      footer={[
        <Button className="cancel-btn" onClick={goToMyMachines}>
          {t('deletionModal.deleted.backButton')}
        </Button>
      ]}>
      <pre className="machine-deleted-modal whitespace-normal">
        {t('deletionModal.deleted.description')}
      </pre>
    </Modal>
  );
};

MachineDeletedModal.propTypes = {
  visible: PropTypes.bool.isRequired
};
